import React, { useContext } from "react";
import { Container } from "semantic-ui-react";
import { List } from "semantic-ui-react";
import { AuthContext } from "../context/auth";
import { Card } from "semantic-ui-react";

function Home() {
  const { user } = useContext(AuthContext);

  const description = [
    "This is the ultimate dynasty baseball tool. Perfect for prospect enthusiasts.",
    "This is the best place to view rankings of all the top prospects from various sites while being able to keep a watchlist of these players and manage your team.",
  ].join(" ");

  return (
    <Container style={{ paddingTop: "64px" }}>
      <h1>Welcome!</h1>
      <Card>
        <Card.Content header="About Us" />
        <Card.Content description={description} />
      </Card>
      <div>
        <div>
          <h3 style={{ paddingTop: "32px" }}>Useful Links:</h3>
        </div>
        {user && (
          <List size="large">
            <List.Item href="https://fantasyrundown.com/">
              Fantasy Rundown
            </List.Item>
            <List.Item href="https://www.fangraphs.com/prospects/the-board/2021-prospect-list/summary?sort=-1,1">
              Fangraphs Board
            </List.Item>
            <List.Item href="https://www.prospectslive.com/">
              Prospects Live
            </List.Item>
            <List.Item href="https://www.espn.com/search/_/q/kiley%20mcdaniel">
              Kiley ESPN Articles
            </List.Item>
          </List>
        )}
      </div>
    </Container>
  );
}

export default Home;
